/* TRATANTE® v2 — tema Shopify · lógica
   1 utilitários · 2 janelas · 3 carrinho · 4 transições (cortina + revelação)
   5 entrada · 6 coleção · 7 produto · 8 scroll · 9 arranque */
(() => {
'use strict';
/* ---------- 1 · UTILITÁRIOS ---------- */
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const T = window.TRT || {};
const mq = matchMedia('(prefers-reduced-motion: reduce)');
let RM = mq.matches; mq.addEventListener && mq.addEventListener('change', e => { RM = e.matches; });
const HOVER = matchMedia('(hover:hover) and (pointer:fine)').matches;
const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const ss = { get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }, del(k) { try { sessionStorage.removeItem(k); } catch (e) {} } };
const ls = { get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
function money(cents) {
  const fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
  const n = (cents || 0) / 100;
  const two = (d, t, dec) => { const [i, f] = n.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? d + f : ''); };
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
    if (k === 'amount') return two('.', ',', 2);
    if (k === 'amount_no_decimals') return two('.', ',', 0);
    if (k === 'amount_with_comma_separator') return two(',', '.', 2);
    if (k === 'amount_no_decimals_with_comma_separator') return two(',', '.', 0);
    if (k === 'amount_with_apostrophe_separator') return two('.', "'", 2);
    return two(',', '.', 2);
  }).replace(/<[^>]*>/g, '');
}
const pname = t => { const s = String(t || '').replace(/[“”„]/g, '"').split('"'); return (s.length > 1 && s[1].trim()) ? s[1].trim() : String(t || '').replace(/"/g, '').trim(); };
function say(msg) { const l = $('#live'); if (!l) return; l.textContent = ''; setTimeout(() => { l.textContent = msg; }, 60); }
let toastT;
function toast(msg) { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 2400); say(msg); }
const SW = { preto: '#111', branco: '#fff', areia: '#D8C8A8', verde: '#5B6B45', vermelho: '#7A1F2B', azul: '#3E5C9A', rosa: '#E8A6B8', cinza: '#9A9A96', bege: '#D9C7A7' };

/* ---------- 2 · JANELAS (foco preso, fundo inerte, Esc, devolve o foco) ---------- */
const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea,[tabindex]:not([tabindex="-1"])';
let openDlg = null, retFocus = null;
const inerted = [];
function openDialog(d, opener) {
  if (!d || openDlg === d) return;
  if (d.parentElement !== document.body) document.body.appendChild(d); // janelas das secções saem de #app para não ficarem inertes
  const ret = openDlg ? retFocus : (opener || document.activeElement);
  if (openDlg) closeDialog(false, true);
  retFocus = ret; openDlg = d;
  d.hidden = false; void d.offsetWidth; d.classList.add('on');
  const sc = $('#scrim'); if (d.id !== 'zoom') { sc.hidden = false; void sc.offsetWidth; sc.classList.add('on'); }
  document.body.classList.add('locked');
  [...document.body.children].forEach(el => { if (el !== d && el !== sc && el.id !== 'live' && el.id !== 'toast' && el.tagName !== 'SCRIPT' && !el.inert) { el.inert = true; inerted.push(el); } });
  let f = $(FOCUSABLE, $('.db', d) || d) || $(FOCUSABLE, d);
  if (f && f.matches('input[type=search]')) f = $('[data-close]', d) || f; // não abrir o teclado no telemóvel
  setTimeout(() => { if (openDlg === d && f) f.focus({ preventScroll: true }); }, 30);
}
function closeDialog(restore = true, swap = false) {
  const d = openDlg; if (!d) return;
  openDlg = null; d.classList.remove('on');
  setTimeout(() => { if (openDlg !== d) d.hidden = true; }, RM ? 0 : 420);
  while (inerted.length) inerted.pop().inert = false;
  if (swap) return;
  const sc = $('#scrim'); sc.classList.remove('on'); setTimeout(() => { if (!openDlg) sc.hidden = true; }, RM ? 0 : 320);
  document.body.classList.remove('locked');
  if (restore && retFocus && document.contains(retFocus)) retFocus.focus({ preventScroll: true });
  retFocus = null;
}
document.addEventListener('keydown', e => {
  if (!openDlg) return;
  if (e.key === 'Escape') { e.preventDefault(); closeDialog(); return; }
  if (e.key !== 'Tab') return;
  const f = $$(FOCUSABLE, openDlg).filter(x => x.offsetParent !== null);
  if (!f.length) return;
  const first = f[0], last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});
document.addEventListener('click', e => {
  const o = e.target.closest('[data-open]');
  if (o) { const d = $('#' + o.dataset.open); if (d) { e.preventDefault(); if (d.id === 'cart') loadCart(); openDialog(d, o); } return; }
  const c = e.target.closest('[data-close]');
  if (c && openDlg && openDlg.contains(c)) { closeDialog(!c.getAttribute('href')); }
});
document.addEventListener('DOMContentLoaded', () => { const sc = $('#scrim'); if (sc) sc.addEventListener('click', () => closeDialog()); });

/* ---------- 3 · CARRINHO (Ajax API da Shopify) ---------- */
let cartState = null;
async function loadCart() {
  try { const r = await fetch((T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }); const d = await r.json(); if (!r.ok || !Array.isArray(d.items)) throw new Error('cart'); cartState = d; renderCart(); } catch (e) { $('#cartBody').innerHTML = '<p class="empty">' + __('Não foi possível carregar o carrinho. Tenta outra vez.') + '</p>'; }
}
function setBadges(n) {
  $$('[data-bag]').forEach(b => { b.textContent = n || ''; b.classList.toggle('on', n > 0); });
  const cb = $('#cartBtn'); if (cb) cb.setAttribute('aria-label', n ? __(n === 1 ? 'Carrinho, {n} artigo' : 'Carrinho, {n} artigos', { n: n }) : __('Carrinho, vazio'));
}
function renderCart() {
  const c = cartState; if (!c) return;
  const n = c.item_count; setBadges(n);
  $('#cartT').textContent = n ? `${__('Carrinho')} (${n})` : __('Carrinho');
  const body = $('#cartBody'), foot = $('#cartFoot');
  if (!n) {
    const links = (T.navHandles || '').split(',').map(x => x.split('|')).filter(x => x[0]).map(([h, nm]) => `<a class="lnk" href="${__u('/collections/' + esc(h.trim()))}" style="min-height:44px;display:flex;align-items:center">${esc((nm || h).trim())}</a>`).join('');
    const dc = (c.discount_codes || []).map(d => d.code).filter(Boolean);
    body.innerHTML = `<div class="empty"><p style="margin:0;font-size:17px">${__('O carrinho está vazio.')}</p>${dc.length ? `<p class="dc-note">${__('Código {c} guardado. Desconta quando juntares peças.', { c: '<b>' + esc(dc[0]) + '</b>' })}</p>` : ''}${links}</div>`;
    foot.hidden = true; return;
  }
  body.innerHTML = c.items.map((it, i) => {
    const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    const variant = it.product_has_only_default_variant ? '' : esc(it.variant_title || '');
    return `<div class="line" data-line="${i + 1}" data-key="${esc(it.key)}">
      ${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : '<span></span>'}
      <div><a class="nm" href="${esc(it.url)}">${esc(pname(it.product_title))}</a><div class="sub">${esc(it.product_type || '')}${variant ? ' · ' + variant : ''}</div>
        <div style="display:flex;align-items:center;flex-wrap:wrap"><div class="qty"><button type="button" data-act="dec" aria-label="${__('Menos uma unidade')}"${it.quantity <= 1 ? ' disabled' : ''}>−</button><span aria-label="${__('Quantidade')}">${it.quantity}</span><button type="button" data-act="inc" aria-label="${__('Mais uma unidade')}">+</button></div><button type="button" class="rm" data-act="rm">${__('Remover')}</button></div>
      </div>
      <span class="lp">${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}${money(it.final_line_price)}</span></div>`;
  }).join('');
  const left = (T.freeShipping || 0) - c.total_price;
  foot.hidden = false;
  foot.innerHTML = `
    ${T.freeShipping ? `<div class="freebar">${left > 0 ? `<span>${__('Faltam {v} para portes grátis em Portugal Continental.', { v: '<b>' + money(left) + '</b>' })}</span>` : `<span>${__('{b}Portes grátis{/b} em Portugal Continental.', { b: '<b>', '/b': '</b>' })}</span>`}<div class="tr" aria-hidden="true"><span style="width:${Math.min(100, c.total_price / T.freeShipping * 100)}%"></span></div></div>` : ''}
    ${(c.cart_level_discount_applications || []).filter(d => d.total_allocated_amount > 0).map(d => `<div class="sum sub"><span>${esc(d.title || codesOf(c)[0] || __('Desconto'))}</span><span>−${money(d.total_allocated_amount)}</span></div>`).join('')}
    <div class="sum"><span>${__('Subtotal')}</span><b>${money(c.total_price)}</b></div>
    <p class="note">${esc(T.cartNote || __('Portes calculados no checkout.'))}</p>
    <div id="cartSugg"></div>
    <a class="btn primary full" href="/checkout">${__('Finalizar compra')}</a>`;
  suggest(c);
}
/* sugestão de uma peça para juntar (recomendações da Shopify: complementares, senão relacionadas) */
let suggFor = '';
async function suggest(c) {
  const box = $('#cartSugg'); if (!box || !c.items.length) return;
  const pid = c.items[0].product_id, inCart = new Set(c.items.map(i => i.product_id));
  if (suggFor === pid + ':' + c.item_count && box.dataset.html) { box.innerHTML = box.dataset.html; return; }
  suggFor = pid + ':' + c.item_count;
  try {
    let list = [];
    for (const intent of ['complementary', 'related']) {
      const r = await fetch(__u(`/recommendations/products.json?product_id=${pid}&limit=6&intent=${intent}`));
      if (r.ok) list = ((await r.json()).products || []).filter(p => p.available && !inCart.has(p.id));
      if (list.length) break;
    }
    const p = list[0]; if (!p) { box.innerHTML = ''; return; }
    const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    const html = `<a class="sugg-card" href="${esc(p.url)}"><span class="mono">${__('Junta ao conjunto')}</span>${img ? `<img src="${esc(img)}" alt="" loading="lazy" width="56" height="70">` : ''}<span class="sg-nm">${esc(pname(p.title))}<small>${esc(p.type || '')}</small></span><b>${money(p.price)}</b></a>`;
    box.dataset.html = html; if ($('#cartSugg') === box) box.innerHTML = html;
  } catch (e) { box.innerHTML = ''; }
}
/* códigos de desconto: se uma alteração ao carrinho os perder, volta a aplicá-los */
const codesOf = c => ((c && c.discount_codes) || []).map(d => d.code).filter(Boolean);
async function keepCodes(before, d) {
  const lost = before.filter(x => !codesOf(d).some(y => y.toUpperCase() === x.toUpperCase()));
  if (!lost.length || !d.item_count) return d;
  try {
    const r = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: before.join(',') }) });
    const u = await r.json(); if (r.ok && Array.isArray(u.items) && codesOf(u).length) return u;
  } catch (e) {}
  try { await fetch('/discount/' + encodeURIComponent(lost[0])); const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); const u = await r.json(); if (Array.isArray(u.items)) return u; } catch (e) {}
  return d;
}
async function changeLine(key, qty) {
  const before = codesOf(cartState);
  const r = await fetch((T.routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
  let d = await r.json();
  if (!r.ok || !Array.isArray(d.items)) { toast(d.description || d.message || __('Não há mais stock desta peça.')); await loadCart(); return; }
  // a resposta de /cart/change.js traz os descontos incompletos (título vazio, 0,00 €): lê o carrinho completo
  try { const f = await fetch((T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }); const full = await f.json(); if (Array.isArray(full.items)) d = full; } catch (e) {}
  d = await keepCodes(before, d);
  cartState = d; renderCart();
}
document.addEventListener('click', async e => {
  const b = e.target.closest('#cartBody [data-act]'); if (!b) return;
  const line = b.closest('.line'), key = line.dataset.key, it = cartState.items.find(x => x.key === key);
  if (!it) return;
  b.disabled = true;
  try {
    if (b.dataset.act === 'inc') await changeLine(key, it.quantity + 1);
    else if (b.dataset.act === 'dec') await changeLine(key, it.quantity - 1);
    else { await changeLine(key, 0); say(__('{p} removido do carrinho.', { p: pname(it.product_title) })); const f = $(FOCUSABLE, $('#cart')); if (f) f.focus(); return; }
    say(__('Quantidade atualizada.'));
    const same = $(`.line[data-key="${CSS.escape(key)}"] [data-act="${b.dataset.act}"]`); if (same && !same.disabled) same.focus();
  } catch (err) { toast(__('Não foi possível atualizar. Tenta outra vez.')); }
});
async function addToCart(id, qty = 1) {
  const r = await fetch((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: qty }] }) });
  const data = await r.json();
  if (!r.ok) throw new Error(data.description || data.message || __('Erro'));
  return data;
}

/* ---------- 4 · TRANSIÇÕES: revelação ao scroll + cortina entre coleções ---------- */
let revIO;
function observe() {
  if (revIO) revIO.disconnect();
  if (RM || !('IntersectionObserver' in window)) { $$('.rv').forEach(e => e.classList.add('in')); return; }
  revIO = new IntersectionObserver(es => { es.filter(e => e.isIntersecting).forEach((e, j) => { setTimeout(() => e.target.classList.add('in'), j * 80); revIO.unobserve(e.target); }); }, { rootMargin: '0px 0px -8% 0px', threshold: .05 });
  $$('.rv:not(.in)').forEach(e => revIO.observe(e));
}
function cascadeIn() { $$('.rv:not(.in)').filter(e => e.getBoundingClientRect().top < innerHeight).forEach((e, j) => setTimeout(() => e.classList.add('in'), RM ? 0 : j * 90)); observe(); }
const isColLink = a => a && a.origin === location.origin && /^(\/[a-z]{2}(-[a-z]{2})?)?\/collections\/[^/]+\/?$/i.test(a.pathname) && a.pathname !== location.pathname;
document.addEventListener('click', e => {
  const a = e.target.closest('a[href]');
  if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
  if (a.hasAttribute('data-intro-link')) return; // a entrada tem animação própria
  if (!isColLink(a) || RM) return;
  e.preventDefault();
  if (openDlg) closeDialog(false);
  const w = $('#wipe');
  ss.set('trt-wipe', '1');
  w.animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], { duration: 420, easing: 'cubic-bezier(.76,0,.24,1)', fill: 'forwards' }).onfinish = () => { location.href = a.href; };
});
function wipeOut() {
  if (!document.documentElement.classList.contains('wipe-in')) return false;
  ss.del('trt-wipe');
  const w = $('#wipe');
  document.documentElement.classList.remove('wipe-in');
  if (RM || !w) return true;
  w.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }], { duration: 520, easing: 'cubic-bezier(.76,0,.24,1)', fill: 'forwards' }).onfinish = () => w.getAnimations().forEach(x => x.cancel());
  setTimeout(cascadeIn, 160);
  return true;
}
addEventListener('pageshow', e => { if (e.persisted) { document.documentElement.classList.remove('wipe-in'); ss.del('trt-wipe'); const w = $('#wipe'); if (w) w.getAnimations().forEach(x => x.cancel()); $$('#intro .strip').forEach(s => s.getAnimations().forEach(x => x.cancel())); const i = $('#intro'); if (i) i.classList.remove('leaving'); } });

/* ---------- 5 · ENTRADA (página inicial) ---------- */
function initIntro() {
  const intro = $('#intro'); if (!intro) return;
  const s = $('#strips'), N = 6;
  const desk = matchMedia('(min-width:900px)').matches;
  const src = desk ? intro.dataset.imgD : intro.dataset.imgM;
  for (let i = 0; i < N; i++) {
    const d = document.createElement('div'); d.className = 'strip';
    d.style.left = `calc(${i} * 100% / ${N})`; d.style.width = `calc(100% / ${N} + 1px)`;
    d.innerHTML = `<img src="${src}" alt="" fetchpriority="high" style="left:calc(-${i} * var(--iw) / ${N})">`;
    s.appendChild(d);
  }
  const setIw = () => s.style.setProperty('--iw', s.clientWidth + 'px'); setIw(); addEventListener('resize', setIw);
  $$('[data-intro-link]', intro).forEach(a => a.addEventListener('click', e => {
    if (RM || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    a.classList.add('chosen'); intro.classList.add('leaving');
    const word = $('.disp', a);
    word.animate([{ transform: 'none' }, { transform: 'translateY(-40px) scale(1.05)', offset: .3 }, { transform: 'translateY(-120vh)', opacity: 0 }], { duration: 1000, easing: 'cubic-bezier(.76,0,.24,1)', fill: 'forwards' });
    $$('.strip', intro).forEach((st, i) => st.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-102%)' }], { duration: 850, delay: 120 + i * 65, easing: 'cubic-bezier(.76,0,.24,1)', fill: 'forwards' }));
    ss.set('trt-from-intro', '1');
    setTimeout(() => { location.href = a.href; }, 900);
  }));
}

/* ---------- 6 · COLEÇÃO ---------- */
function initCollection() {
  const grid = $('#grid'); if (!grid) return;
  const title = $('#colTitle');
  if (ss.get('trt-from-intro') && title && !RM) { ss.del('trt-from-intro'); title.animate([{ transform: 'translateY(60px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 700, easing: 'cubic-bezier(.22,1,.36,1)' }); }
  document.addEventListener('pointerover', e => { if (!HOVER) return; const c = e.target.closest && e.target.closest('.card'); const im = c && $('img.alt[data-src]', c); if (im) { im.src = im.dataset.src; im.removeAttribute('data-src'); } });
  // carregar mais peças sem sair da página
  const more = $('#loadMore');
  async function loadMore() {
    const m = $('#loadMore'); if (!m) return false;
    m.setAttribute('aria-busy', 'true'); m.textContent = __('A carregar…');
    try {
      const html = await (await fetch(m.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      $$('#grid > .card, #grid > .feat', doc).forEach(c => { grid.appendChild(document.importNode(c, true)); });
      const nx = $('#loadMore', doc);
      if (nx) { m.href = nx.getAttribute('href'); m.textContent = __('Ver mais peças'); m.removeAttribute('aria-busy'); } else m.parentElement.remove();
      applyFilter(); observe(); return !!nx;
    } catch (e) { m.textContent = __('Ver mais peças'); m.removeAttribute('aria-busy'); return false; }
  }
  if (more) {
    more.addEventListener('click', e => { e.preventDefault(); loadMore(); });
    if ('IntersectionObserver' in window) { const io = new IntersectionObserver(es => { if (es[0].isIntersecting && $('#loadMore') && !$('#loadMore').hasAttribute('aria-busy')) loadMore(); }, { rootMargin: '600px 0px' }); io.observe(more.parentElement); }
  }
  // filtros por tipo de peça (ex.: Hoodies / Sweats)
  let filter = '';
  function applyFilter() { $$('#grid .card').forEach(c => { c.hidden = !!filter && c.dataset.type !== filter; }); $$('#grid .feat').forEach(f => { f.hidden = !!filter; }); }
  $$('#filters [data-filter]').forEach(b => b.addEventListener('click', async () => {
    filter = b.dataset.filter; $$('#filters [data-filter]').forEach(x => x.setAttribute('aria-pressed', x === b));
    applyFilter(); if (filter) { while (await loadMore()) {} }
    say(filter ? `${__('Filtro:')} ${b.textContent}` : __('Todas as peças'));
  }));
}

/* ---------- 7 · PRODUTO ---------- */
function initProduct() {
  const pj = $('#pjson'); if (!pj) return;
  const P = JSON.parse(pj.textContent);
  const form = $('#pform'), idIn = $('#variantId');
  const sets = $$('.opt', form);
  let current = P.variants.find(v => String(v.id) === idIn.value) || P.variants[0];
  const hasSize = sets.some(f => f.dataset.kind === 'size');
  let sizeChosen = !hasSize || new URL(location.href).searchParams.has('variant');
  const sel = current ? current.options.slice() : [];
  const sizeIdx = sets.findIndex(f => f.dataset.kind === 'size');
  // cores: amostra
  $$('.sw', form).forEach(s => { s.style.background = SW[s.dataset.sw] || '#999'; });
  function findVariant() { return P.variants.find(v => v.options.every((o, i) => o === sel[i])); }
  function availFor(idx, value) {
    // cor/outras opções: disponível se existir algum tamanho em stock; tamanho: depende das restantes escolhas
    if (sets[idx].dataset.kind !== 'size') return P.variants.some(v => v.available && v.options[idx] === value);
    return P.variants.some(v => v.available && v.options.every((o, i) => i === idx ? o === value : o === sel[i]));
  }
  function paint() {
    sets.forEach((f, idx) => {
      $$('.chip', f).forEach(ch => {
        const v = ch.dataset.value, on = sel[idx] === v && (f.dataset.kind !== 'size' || sizeChosen);
        const ok = availFor(idx, v);
        ch.setAttribute('aria-pressed', on);
        ch.classList.toggle('out', !ok);
        $('.st', ch).textContent = ok ? '' : ' (' + __('esgotado') + ')';
      });
      const lab = $('[data-opt-label]', f); if (lab) lab.textContent = f.dataset.kind === 'size' && !sizeChosen ? __('por escolher') : sel[idx];
    });
    current = findVariant();
    if (current) idIn.value = current.id;
    const gl = $('[data-guide]', form), ci = sets.findIndex(x => x.dataset.kind === 'color');
    if (gl) { const u = new URL(gl.href, location.origin); if (ci >= 0) u.searchParams.set('cor', sel[ci]); gl.href = u.pathname + u.search; }
    const pr = $('#price'); if (pr && current) pr.textContent = money(current.price);
    const was = $('#was'); if (was) { const c = current && current.compare_at_price > current.price; was.hidden = !c; if (c) was.textContent = money(current.compare_at_price); }
    renderCta();
  }
  function gotoMedia(mid) {
    if (!mid) return; const i = $$('.slide', track).findIndex(s => s.dataset.mediaId === String(mid));
    if (i >= 0) go(i);
  }
  sets.forEach((f, idx) => f.addEventListener('click', e => {
    const ch = e.target.closest('.chip'); if (!ch) return;
    // tamanho esgotado: não escolhe, abre o "Avisa-me" para esse tamanho
    if (f.dataset.kind === 'size' && ch.classList.contains('out')) { openNotify(ch.dataset.value, ch); return; }
    sel[idx] = ch.dataset.value;
    if (f.dataset.kind === 'size') sizeChosen = true;
    paint();
    if (current && current.featured_media && f.dataset.kind !== 'size') gotoMedia(current.featured_media.id);
    if (current && sizeChosen) { const u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u); }
    say(`${ch.dataset.value}${current && !current.available ? ', ' + __('esgotado') : ''}`);
  }));
  const ctaAdd = $('#ctaAdd'), ctaBuy = $('#ctaBuy'), ctaNotify = $('#ctaNotify'), bar = $('#buybar');
  // cor/opção sem nenhum tamanho disponível = esgotada, mesmo antes de escolher tamanho
  const optionOut = () => sets.some((f, idx) => f.dataset.kind !== 'size' && !availFor(idx, sel[idx])) || !P.available;
  function renderCta() {
    const needSize = hasSize && !sizeChosen;
    const out = !current || (needSize ? optionOut() : !current.available);
    ctaAdd.disabled = out;
    ctaAdd.innerHTML = !current ? __('Indisponível') : out ? __('Esgotado') : __('Adicionar') + '<span class="lg"> ' + __('ao carrinho') + '</span>';
    ctaBuy.hidden = out;
    if (ctaNotify) ctaNotify.hidden = !out || !current;
    if (!bar) return;
    if (out) bar.innerHTML = current ? `<button class="btn primary" type="button" id="bbNotify">${__('Esgotado')} · ${__('Avisa-me')}</button>` : `<button class="btn primary" type="button" disabled>${__('Indisponível')}</button>`;
    else if (needSize) bar.innerHTML = `<button class="btn primary" type="button" id="bbPick">${__('Escolher tamanho')} · ${money(current.price)}</button>`;
    else bar.innerHTML = `<button class="btn primary" type="button" id="bbAdd">${__('Adicionar')}${hasSize ? ' · ' + esc(sel[sizeIdx]) : ''} · ${money(current.price)}</button><button class="btn ghost" type="button" id="bbBuy">${__('Comprar já')}</button>`;
    const bn = $('#bbNotify'); if (bn) bn.onclick = e => openNotify(needSize ? null : sel[sizeIdx], e.currentTarget);
    const pick = $('#bbPick'); if (pick) pick.onclick = e => openSizeSheet(e.currentTarget);
    const ba = $('#bbAdd'); if (ba) ba.onclick = e => doAdd(e.currentTarget, false);
    const bb = $('#bbBuy'); if (bb) bb.onclick = e => doAdd(e.currentTarget, true);
  }
  function needSizeNudge(fromBar) {
    const f = sets[sizeIdx]; if (!f) return;
    f.scrollIntoView({ block: 'center', behavior: RM ? 'auto' : 'smooth' });
    const ch = $('.chips', f); ch.classList.remove('shake'); void ch.offsetWidth; if (!RM) ch.classList.add('shake');
    toast(__('Escolhe um tamanho primeiro.'));
    const first = $('.chip:not(.out)', f); if (first) setTimeout(() => first.focus({ preventScroll: true }), RM ? 0 : 350);
  }
  async function doAdd(btn, buyNow) {
    if (hasSize && !sizeChosen) return needSizeNudge();
    if (!current || !current.available) return toast(__('Esta opção está esgotada.'));
    btn.disabled = true;
    if (buyNow) { location.href = '/cart/' + current.id + ':1'; return; }
    try {
      await addToCart(current.id, 1);
      say(`${__('Adicionado ao carrinho:')} ${pname(P.title)}${current.public_title ? ', ' + current.public_title : ''}.`);
      await loadCart(); openDialog($('#cart'), btn);
    } catch (err) { toast(err.message || __('Não foi possível adicionar.')); }
    finally { btn.disabled = false; }
  }
  // folha de tamanhos (barra fixa no telemóvel)
  function openSizeSheet(opener) {
    const f = sets[sizeIdx]; if (!f) return needSizeNudge(true);
    const body = $('#sizeSheetBody'); if (!body) return needSizeNudge(true);
    const colIdx = sets.findIndex(x => x.dataset.kind === 'color');
    const chips = $$('.chip', f).map(ch => { const v = ch.dataset.value, ok = availFor(sizeIdx, v); return `<button type="button" class="chip${ok ? '' : ' out'}" data-ssz="${esc(v)}" aria-pressed="${sizeChosen && sel[sizeIdx] === v}">${esc(v)}${ok ? '' : '<span class="sr"> (' + __('esgotado, toca para seres avisado') + ')</span>'}</button>`; }).join('');
    const g = $('[data-guide]', form);
    body.innerHTML = `<p style="margin:0">${esc(pname(P.title))}${colIdx >= 0 ? ' · ' + esc(sel[colIdx]) : ''}</p><div class="chips" id="sheetChips">${chips}</div>${g ? `<a class="lnk" href="${esc(g.href)}" style="min-height:44px;display:inline-flex;align-items:center">${__('Não sabes o tamanho? Usa o Fast Size')}</a>` : ''}`;
    $('#sheetChips').onclick = e => {
      const b = e.target.closest('[data-ssz]'); if (!b) return;
      if (b.classList.contains('out')) { openNotify(b.dataset.ssz, opener); return; }
      sel[sizeIdx] = b.dataset.ssz; sizeChosen = true;
      closeDialog(false); paint();
      if (current) { const u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u); }
      say(__('Tamanho {s} escolhido.', { s: sel[sizeIdx] }));
      const nb = $('#bbAdd'); if (nb) nb.focus({ preventScroll: true });
    };
    openDialog($('#sizeSheet'), opener);
  }
  // Avisa-me: pedido por email à loja (formulário de contacto da Shopify)
  // Avisa-me: primeiro a app Kbite (envia sozinha quando volta ao stock); sem ela, pedido por email à loja
  const kbiteTrigger = () => {
    for (const h of $$('[gw-stock-fulfilled],[id*="kbite" i],[class*="kbite" i],[id*="cartbite" i],[class*="cartbite" i]')) {
      if (h.closest('#notify')) continue;
      const b = h.matches('button,a,[role="button"]') ? h : $('button,a,[role="button"]', h);
      if (b) return b;
    }
    return null;
  };
  function openNotify(size, opener) {
    if (T.notifyMode === 'email') return openOwn(size, opener);
    const opts = sel.slice(); if (size && sizeIdx >= 0) opts[sizeIdx] = size;
    const v = P.variants.find(x => x.options.every((o, i) => o === opts[i]));
    if (size && sizeIdx >= 0 && (sel[sizeIdx] !== size || !sizeChosen)) { sel[sizeIdx] = size; sizeChosen = true; paint(); }
    if (v) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); idIn.dispatchEvent(new Event('change', { bubbles: true })); document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } })); }
    if (openDlg) closeDialog(false);
    // Kbite (Cartbite): abre a janela da app diretamente para esta variante
    const G = window.growConfig;
    if (G && typeof G.stockWidgetClicked === 'function' && document.getElementById('gw-stock-fulfilled-iframe')) {
      const t = document.createElement('button');
      t.setAttribute(G.dataProductId || 'data-product-id', P.id);
      t.setAttribute(G.dataVariantId || 'data-variant-id', v ? v.id : current.id);
      t.setAttribute(G.dataProductHandle || 'data-product-handle', P.handle);
      Promise.resolve(G.stockWidgetClicked({ target: t, preventDefault() {} })).catch(() => openOwn(size, opener));
      return;
    }
    setTimeout(() => { const k = kbiteTrigger(); if (k) k.click(); else openOwn(size, opener); }, 300);
  }
  function openOwn(size, opener) {
    const d = $('#notify'); if (!d) return;
    const what = $('#notifyWhat');
    const opts = sel.slice(); if (size && sizeIdx >= 0) opts[sizeIdx] = size;
    const v = P.variants.find(x => x.options.every((o, i) => o === opts[i]));
    const colIdx = sets.findIndex(x => x.dataset.kind === 'color');
    const bits = [pname(P.title)]; if (colIdx >= 0) bits.push(opts[colIdx]); if (size) bits.push(__('tamanho') + ' ' + size);
    if (what) what.textContent = __('{p} está esgotado. Deixa o email e avisamos quando voltar.', { p: bits.join(' · ') });
    const nw = $('#ntWhat'); if (nw) nw.value = `${P.title}${v ? ' · ' + v.title : (size ? ' · ' + size : '')}`;
    const nl = $('#ntLink'); if (nl && v) nl.value = `${location.origin}${location.pathname}?variant=${v.id}`;
    openDialog(d, opener);
  }
  if (ctaNotify) ctaNotify.addEventListener('click', e => openNotify(hasSize && sizeChosen ? sel[sizeIdx] : null, e.currentTarget));
  const qsP = new URLSearchParams(location.search);
  if (/contact_posted=true/.test(location.search) && location.hash === '#avisaForm') setTimeout(() => openDialog($('#notify')), 350);
  else if (qsP.get('avisa') === '1') setTimeout(() => openNotify(hasSize && sizeChosen ? sel[sizeIdx] : null), 350);
  form.addEventListener('submit', e => { e.preventDefault(); doAdd(ctaAdd, false); });
  ctaBuy.addEventListener('click', e => doAdd(e.currentTarget, true));
  // descrição: Ler mais
  const desc = $('#desc'), more = $('#more');
  if (desc && more && desc.scrollHeight > desc.clientHeight + 4) { more.hidden = false; more.onclick = () => { const o = !desc.classList.contains('open'); desc.classList.toggle('open', o); more.textContent = o ? __('Ler menos') : __('Ler mais'); more.setAttribute('aria-expanded', o); }; }
  // galeria: uma foto de cada vez, swipe com parallax
  const track = $('#track'), n = $$('.slide', track).length;
  const cur = () => Math.min(n - 1, Math.round(track.scrollLeft / (track.clientWidth || 1)));
  const go = i => track.scrollTo({ left: Math.max(0, Math.min(n - 1, i)) * track.clientWidth, behavior: RM ? 'auto' : 'smooth' });
  const onTrack = () => {
    const w = track.clientWidth || 1, x = track.scrollLeft, i = cur();
    $$('#seg button').forEach((b, k) => b.setAttribute('aria-current', k === i));
    const gb = $('#galBar'); if (gb) gb.style.transform = `scaleX(${Math.min(1, (x / w + 1) / n)})`;
    if (!RM) $$('.slide img', track).forEach((img, k) => { const d = (x - k * w) / w; img.style.transform = `translate3d(${(d * w * .28).toFixed(1)}px,0,0) scale(${(1 + Math.min(1, Math.abs(d)) * .06).toFixed(3)})`; });
  };
  if (n) {
    track.addEventListener('scroll', () => requestAnimationFrame(onTrack), { passive: true });
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(cur() + (e.key === 'ArrowRight' ? 1 : -1)); } });
    $$('#seg button').forEach(b => b.onclick = () => go(+b.dataset.i));
    const gp = $('#galPrev'), gn = $('#galNext'); if (gp) gp.onclick = () => go(cur() - 1); if (gn) gn.onclick = () => go(cur() + 1);
    const zoom = (src, opener) => { const z = $('#zoom'), img = $('#zoomImg'), box = $('#zoomIn'); img.onload = () => { box.scrollLeft = (box.scrollWidth - box.clientWidth) / 2; box.scrollTop = (box.scrollHeight - box.clientHeight) / 2; }; img.src = src; img.alt = __('Fotografia ampliada de') + ' ' + pname(P.title); openDialog(z, opener); };
    track.addEventListener('click', e => { const f = e.target.closest('.slide'); if (f) zoom(f.dataset.full, f); });
    $('#zoomBtn').onclick = e => zoom($$('.slide', track)[cur()].dataset.full, e.currentTarget);
    onTrack();
    if (current && current.featured_media && new URL(location.href).searchParams.has('variant')) setTimeout(() => gotoMedia(current.featured_media.id), 50);
    if (!RM && n > 1) setTimeout(() => { if (track.scrollLeft < 5) { track.classList.add('nudge'); track.addEventListener('animationend', () => track.classList.remove('nudge'), { once: true }); } }, 900);
  }
  // voltar à coleção: se viemos dela, recua no histórico (volta ao sítio exato)
  const back = $('#backCol');
  if (back) back.addEventListener('click', e => {
    try { const r = new URL(document.referrer); if (r.origin === location.origin && r.pathname.replace(/\/$/, '').endsWith('/collections/' + back.dataset.col) && history.length > 1) { e.preventDefault(); e.stopPropagation(); history.back(); } } catch (err) {}
  }, true);
  paint();
  window.__barCheck = () => { const c = $('#cta'); if (!c || !bar) return; const r = c.getBoundingClientRect(); bar.classList.toggle('on', !(r.top < innerHeight - 70 && r.bottom > 60)); };
  window.__pinScroll = () => {
    const w = $('#pinWrap'); if (!w || RM) return;
    const r = w.getBoundingClientRect(), pin = $('#pin');
    const total = r.height - pin.offsetHeight, pr = Math.min(1, Math.max(0, -r.top / (total || 1)));
    const z = Math.min(1, pr / .42), ez = 1 - Math.pow(1 - z, 3);
    $('#pinPack').style.transform = `scale(${1 + ez * 1.35})`;
    const q1 = pr < .18 ? 0 : pr < .3 ? (pr - .18) / .12 : pr < .52 ? 1 : pr < .6 ? 1 - (pr - .52) / .08 : 0;
    $('#q1').style.opacity = q1.toFixed(3); $('#q1').style.transform = `translateY(${(1 - q1) * 18}px)`;
    const m = pr < .58 ? 0 : pr < .72 ? (pr - .58) / .14 : 1;
    $('#pinModel').style.opacity = m.toFixed(3);
    const q2 = pr < .78 ? 0 : pr < .88 ? (pr - .78) / .1 : 1;
    $('#q2').style.opacity = q2.toFixed(3); $('#q2').style.transform = `translateY(${(1 - q2) * 18}px)`;
    $('#pinStep').textContent = pr < .34 ? '01 / 03' : pr < .66 ? '02 / 03' : '03 / 03';
    $('#pinBar').style.width = (pr * 100).toFixed(1) + '%';
  };
  window.__barCheck();
}

/* ---------- 8 · SCROLL ---------- */
let lastY = 0, ticking = false;
function onScroll() {
  if (ticking) return; ticking = true;
  requestAnimationFrame(() => {
    ticking = false;
    const y = scrollY, hdr = $('#hdr'), tw = $('#tabsWrap');
    if (hdr) hdr.classList.toggle('scrolled', y > 4);
    if (tw) { if (y > lastY + 6 && y > 200) tw.classList.add('hid'); else if (y < lastY - 6 || y < 200) tw.classList.remove('hid'); }
    lastY = y;
    if (!RM) $$('.feat img').forEach(img => { const r = img.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; const t = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; img.style.transform = `translate3d(0,${(-t * 40).toFixed(1)}px,0)`; });
    if (window.__barCheck) window.__barCheck();
    if (window.__pinScroll) window.__pinScroll();
  });
}

/* ---------- 9 · ARRANQUE ---------- */
window.TRTui = { openDialog, closeDialog, toast, say, esc, money, pname, $, $$, loadCart, keepCodes, codesOf };
/* editor de temas: ao mudar uma secção, volta a montar o que o JavaScript desenha (evita fotos pretas/secções vazias) */
function reloadScript(name) { const o = $$('script[src*="' + name + '"]')[0]; if (!o) return; const n = document.createElement('script'); n.src = o.src.split('#')[0]; document.body.appendChild(n); }
document.addEventListener('shopify:section:load', e => {
  const s = e.target;
  $$('.rv', s).forEach(x => x.classList.add('in'));
  try { if ($('#intro', s)) initIntro(); if ($('#grid', s)) initCollection(); if ($('#pjson', s)) initProduct(); } catch (err) { console.error(err); }
  if ($('#brandPage', s)) reloadScript('brand.js');
  if ($('#fs', s) || $('#gTables', s)) reloadScript('guide.js');
  document.documentElement.classList.remove('wipe-in');
});
function boot() {
  const nb = $('#nlbar'), nx = $('#nlX');
  if (nb && ls.get('trt-nlbar')) nb.hidden = true;
  if (nx) nx.addEventListener('click', () => { nb.hidden = true; ls.set('trt-nlbar', '1'); });
  const tabs = $('#tabs'); if (tabs) { const act = $('[aria-current]', tabs); if (act) tabs.scrollLeft = Math.max(0, act.offsetLeft - 24); }
  [initIntro, initCollection, initProduct].forEach(f => { try { f(); } catch (e) { console.error(e); } });
  if (!wipeOut()) cascadeIn();
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
  if ((window.Shopify && Shopify.designMode) || location.pathname.startsWith('/cart')) return;
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
